import React, { RefObject } from 'react';

type ContextProps = {
    bottomPanelRef: RefObject<HTMLDivElement | null>;
    studyNumber: string;
};
export const MonitoringToolkitContext = React.createContext<ContextProps>({} as ContextProps);
